import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PopupLoginComponent } from 'src/app/components/modals/popup-login/popup-login.component';
import { PopupRealTimeBiddingComponent } from 'src/app/components/modals/popup-real-time-bidding/popup-real-time-bidding.component';
import { IAnimal } from 'src/app/models/animal';
import { IAuctionBid, IOpenedSchedule } from 'src/app/models/transactions';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-live-bid-action',
  templateUrl: './live-bid-action.component.html',
  styleUrls: ['./live-bid-action.component.scss'],
})
export class LiveBidActionComponent implements OnInit {
  @Input() animal_obj: IAnimal = {} as IAnimal;
  @Input() auction_bid: IAuctionBid = {} as IAuctionBid;
  @Input() opened_schedule: IOpenedSchedule = {} as IOpenedSchedule;

  @Input() is_live: 'LIVE' | 'DETAILS' = 'LIVE';
  @Input() bid_status: 'FINISH' | 'REAL_TIME' | 'OPEN' | 'CLOSED' = 'OPEN';
  @Input() next_bid: any = 0;
  @Input() increment: any = [];
  @Input() list_bids: any = [];
  @Input() attual_bid = 0;
  @Input() isStatus: 'ACEITO' | 'SUPERADO' | 'RECUSADO' |  'AGUARDANDO'  | '' = '';
  @Output() eventSocket = new EventEmitter<any>();

  user = this.storage.myself;

  constructor(private storage: StorageService, private dialog: MatDialog) {}

  ngOnInit() {
    console.log('---------LANCE VIRTUAL---------');
  }

  openOnlineBidPopup() {
    if (!this.storage.token || this.storage.token === '') {
      this.openPopuplogIn();
      return;
    }

    const dialogRef = this.dialog.open(PopupRealTimeBiddingComponent, {
      width: '90%',
      maxWidth: '500px',
      disableClose: true,
      data: {
        // id: this.auction_bid?.id,
        animal: this.animal_obj,
        increment: this.increment,
        auction_bid: this.auction_bid,
        attual_bid: this.attual_bid + this.increment || 0,
        next_bid: this.next_bid,
        max_bid: this.attual_bid * (this.attual_bid < 100 ? 3.5 : 1.5),
        enableBid: true,
        timer: null,
        type: 'VIRTUAL',
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result.action === 'yes') {
        this.eventSocket.emit(true);
      }
    });
  }

  openPopuplogIn() {
    const popupLoginRef = this.dialog.open(PopupLoginComponent, {
      width: '90%',
      maxWidth: '400px',
    });
    popupLoginRef.afterClosed().subscribe((result: any) => {
      if (result.action === 'yes') {
        this.eventSocket.emit(false);
      }
    });
  }
}
